import { motion, useScroll, useTransform } from "framer-motion";
interface HeadingSampleProps {
    subtitle: string;
    title: string[];
}

const HeadingSample: React.FC<HeadingSampleProps> = ({ subtitle, title }) => {
    const { scrollYProgress } = useScroll(); 
    const textY = useTransform(scrollYProgress, [0, 0.6], [0, 100]);
    return (
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 2, type: "spring", bounce: 0.4 }}
                style={{ y: textY }}
                className="w-full h-full flex flex-col items-center justify-center lg:justify-end lg:items-start p-4 backdrop-blur-sm ">
                <div className="w-full flex flex-col items-center lg:items-start justify-center gap-[10px] text-center text-[#000000] text-4xl sm:text-6xl lg:text-9xl font-bungeeinline font-normal leading-[38.34px] lg:px-28 lg:py-20  blur-none">
                    <div className="flex flex-row justify-start items-center text-white text-[20px] uppercase z-30">                        
                        {subtitle}
                    </div>
                    <div className={`font-normal uppercase text-[${title[1]}] leading-tight z-30`}>
                        {title[0]}
                    </div>

                </div>
            </motion.div>
    );
};
export default HeadingSample;
